import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { Dialog } from "../framework/dialog";
import { Radio } from "ui/Scripts/source/components/framework/radio";
import { DialogButtonType } from "ui/Scripts/source/models/enums";

//DocumentListSearchDialog
//***************************************************************
export interface IDocumentListSearchDialogProp {
    classes?: string;
    filter: string;
    sortColumn: string;
    sortOrderIsAsc: boolean;
    onOk: (filter: string, sortColumn: string, sortOrderIsAsc: boolean, searchInUse: boolean) => void;
    onClear: () => void;
    onCancel: () => void;
}

export interface IDocumentListSearchDialogState {
    filter: string;
    sortColumn: string;
    sortOrderIsAsc: boolean;
}

export class DocumentListSearchDialog extends React.Component<IDocumentListSearchDialogProp, IDocumentListSearchDialogState> {
    constructor(props) {
        super(props);
        this.state = {
            filter: props.filter ?? "",
            sortColumn: props.sortColumn ?? "date",
            sortOrderIsAsc: props.sortOrderIsAsc
        };
    }

    handleChange = (event) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        if (name === "filter") {
            this.setState({ filter: value });
        }
    };

    handleSortColumnChange = (sortColumn: string) => {
        this.setState({ sortColumn });
    };

    handleSortOrderIsAscChange = (sortOrderIsAsc: boolean) => {
        this.setState({ sortOrderIsAsc });
    };

    handleOkClick = () => {
        const state = this.state;
        this.props.onOk(state.filter, state.sortColumn, state.sortOrderIsAsc, true);
    };

    handleCancelClick = () => {
        this.props.onCancel();
    };

    handleClearClick = () => {
        this.props.onClear();
        //this.setState({ filter: "", sortColumn: "", sortOrderIsAsc: false });
    };

    render() {
        const props = this.props;
        const state = this.state;
        const dialogClasses = "documentListSearchDialog" + (props.classes ? " " + props.classes : "");
        return (
            <Dialog
                classes={dialogClasses}
                title={Translations.SearchDocuments}
                body={
                    <div>
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group roWhite">
                                    <label className="control-label">{Translations.SearchCondition}</label>
                                    <input className="form-control" type="text" name="filter" title={Translations.SearchCondition} maxLength={50} readOnly={false} disabled={false} value={state.filter} required={true} onChange={this.handleChange} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group">
                                    <label className="control-label">{Translations.Sorting}</label>
                                    <div>
                                        <Radio
                                            title={Translations.ByName}
                                            checked={state.sortColumn === "code"}
                                            onClickBoolean={(checked: boolean) => { this.handleSortColumnChange(checked ? "code" : "date"); }}
                                        />
                                        <Radio
                                            title={Translations.ByDate}
                                            checked={state.sortColumn !== "code"}
                                            onClickBoolean={(checked: boolean) => { this.handleSortColumnChange(checked ? "date" : "code"); }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group">
                                    <label className="control-label">{Translations.Order}</label>
                                    <div>
                                        <Radio
                                            title={Translations.Ascending}
                                            checked={state.sortOrderIsAsc}
                                            onClickBoolean={(checked: boolean) => { this.handleSortOrderIsAscChange(checked); }}
                                        />
                                        <Radio
                                            title={Translations.Descending}
                                            checked={!state.sortOrderIsAsc}
                                            onClickBoolean={(checked: boolean) => { this.handleSortOrderIsAscChange(!checked); }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                buttons={[
                    { title: Translations.OK, buttonType: DialogButtonType.Primary, onClick: this.handleOkClick },
                    { title: Translations.Clear, buttonType: DialogButtonType.Default, onClick: this.handleClearClick },
                    { title: Translations.Cancel, buttonType: DialogButtonType.Default, onClick: this.handleCancelClick }
                ]}
                onClose={this.handleCancelClick}/>
        );
    }
}